module.exports = __webpack_public_path__ + "static/media/drive-lah-logo.d921ce5b.svg";